import React, { Component }          from 'react';

import icPencil                      from '../../img/ic_pencil.svg';
import icMore                        from '../../img/ic_more.svg';
import icAdd                         from '../../img/ic_add.svg';
import icLeftArrow                   from '../../img/ic_left_arrow.svg';
import icRightArrow                  from '../../img/ic_right_arrow.svg';

import "./Admins.scss";

class Admins extends Component {

  constructor(props) {
    super(props);

    this.state            = {
    }
  }

  sendInviteEmail(admin) {
    this.props.sendPasswordSetEmail(admin);
    this.dismissMoreMenu();
  }

  renderLineItems() {
    let lineItems = [];
    for (let i = 0; i < this.props.admins.length; i++) {
      lineItems.push(
        <div className="line-item" key={i}>
            <div className="fields">
              <div className="field">{this.props.admins[i].email}</div>
              <div className="field">{this.props.admins[i].firstName} {this.props.admins[i].lastName}</div>
              <div className="field">{this.props.admins[i].role}</div>
            </div>
            <div className="icons">
              <img onClick={() => this.props.showEditDialog(this.props.admins[i])} src={icPencil} />
              <img onClick={() => this.showMoreMenu(i)} src={icMore} />
              <div className={`more-menu ${this.state.moreMenuIndex === i ? 'show' : ''}`}>
                <div onClick={() => this.sendInviteEmail(this.props.admins[i])} className="item">Send Invite Email</div>
              </div>
            </div>
        </div>
      );
    }
    return lineItems;
  }

  showMoreMenu(i) {
    this.setState({moreMenuIndex: i})
  }

  dismissMoreMenu() {
    this.setState({moreMenuIndex: -1})
  }

  renderPagingNumbers() {
    const pageSize = 8;
    const firstItem = this.props.currentPage * pageSize + 1;
    const lastItem = firstItem + pageSize >= this.props.maxResults ? this.props.maxResults : firstItem + pageSize - 1; 
    return `${firstItem}-${lastItem} of ${this.props.maxResults}`;
  }

  render() {
    return (
      <div className={`admins__container ${this.props.currentState === "ADMINS" ? 'show' : ''}`}>
        <div className="line-item-header">
          <div className="column-names">
            <div className="name">Email</div>
            <div className="name">Name</div>
            <div className="name">Role</div>
          </div>
          <div className="icons">
            <div className="paging">
              <img className={`${this.props.currentPage === 0 ? 'disable' : 'enable'}`} onClick={() => this.props.decrementPage("RECORDINGS")} src={icLeftArrow}/>
              <div className="page-numbers">{this.renderPagingNumbers()}</div>
              <img className={`${(this.props.currentPage + 1)*8 >= this.props.maxResults ? 'disable' : 'enable'}`} onClick={() => this.props.incrementPage("RECORDINGS")} src={icRightArrow}/>
            </div>
            <img onClick={() => this.props.showAddDialog()} src={icAdd}/>
          </div>
        </div>
        <div className="line-items-container">
          <div className="line-items">
            { this.renderLineItems() }
          </div>
        </div>
        <div onClick={this.dismissMoreMenu.bind(this)} className={`more-menu-click-target ${this.state.moreMenuIndex >= 0 ? 'show' : ''}`}></div>
      </div>
    );
  }
}

export default Admins;